// @flow

import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setUIState } from 'redux/modules/ui'
import SearchHeader from 'components/organisms/SearchHeader'
import SearchForm from 'containers/organisms/SearchForm'
import Path from 'routes/path'
import {
  convertSnakeCaseSearchCondition,
  queryStringStringify,
} from 'helpers/search'

type PropTypes = {
  data: {
    amenities: {
      results: Array<Object>,
    },
    eventTypes: {
      results: Array<Object>,
    },
    capacities: {
      results: Array<Object>,
    },
    sponsoredPromotions: {
      results: Array<Object>,
    },
  },
  ui: Object,
  showForm: boolean,
  onClick: Function,
}

class SearchHeaderContainer extends Component<PropTypes> {
  render() {
    const { data, showForm, onClick } = this.props
    const { amenities, eventTypes, capacities, sponsoredPromotions } = data

    return (
      <Fragment>
        <SearchHeader onClick={onClick} />
        {showForm && (
          <SearchForm
            onSubmit={() => {
              const { ui } = this.props
              const searchCondition = convertSnakeCaseSearchCondition(
                ui.searchCondition || {},
              )
              window.location = `${Path.search()}?${queryStringStringify(
                searchCondition,
              )}&with_recommend=true`
            }}
            amenities={amenities ? amenities.results : []}
            eventTypes={eventTypes ? eventTypes.results : []}
            capacities={capacities ? capacities.results : []}
            sponsoredPromotions={
              sponsoredPromotions ? sponsoredPromotions.results : []
            }
          />
        )}
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    ui: state.ui,
  }
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchHeaderContainer)



// WEBPACK FOOTER //
// ./src/containers/organisms/SearchHeader/index.jsx